import Alerts from './Alerts.vue';

export default Alerts;
